/**
 * 
 */
export enum EngineDebugType {
  CONTROLS = 'CONTROLS',
  SELECTED_OBJECT = 'SELECTED_OBJECT',
  OBJECT_LABELS = 'OBJECT_LABELS',
  PATH_FINDING = 'PATH_FINDING',

  /**
   * Walkmesh
   */
  ROOM_WALKMESH = 'ROOM_WALKMESH',
  DOOR_WALKMESH = 'DOOR_WALKMESH',
  PLACEABLE_WALKMESH = 'PLACEABLE_WALKMESH',
  COLLISION_HELPERS = 'COLLISION_HELPERS',
  LIGHT_HELPERS = 'LIGHT_HELPERS',
  SHADOW_LIGHTS = 'SHADOW_LIGHTS',
}